import React, {useEffect, useRef, useState} from 'react';
import {IDepotInfo, IDepotSummary} from '../../Foundations/Types/IDepot';
import CircleMapMarker from './CircleMapMarker';
import {getSupplierName} from '../../Foundations/Utils/SupplierUtils';
import {renderTriangle} from './DepotMapMarker';

interface IProps {
    depot: IDepotInfo,
    lat: number,
    lng: number,
    circleRadius: number,
    depotSummary: IDepotSummary[] | null
}

// @todo Rename to something ore appropriately since it also showing depot with empty result
const OutOfBoundDepotMarker: React.FC<IProps> = ({depot, circleRadius, depotSummary}) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const hasResult = depotSummary === null ? false : !!depotSummary.find((d) => depot.supplier_code === d.supplier_code && d.depot_code === depot.code);
    const isInsideCircle = parseFloat(depot.distance) <= (circleRadius / 1000)
    const containerRef = useRef(null)
    const handleClick = () => {
        setIsExpanded(!isExpanded)
    }

    useEffect(() => {
        const listener = (event) => {
            // @ts-ignore
            if (!containerRef || !containerRef.current || containerRef.current.contains(event.target)) {
                return;
            }

            setIsExpanded(false)
        };
        document.addEventListener('mousedown', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
        };
    }, [])

    if (hasResult) {
        return  null
    }

    return (
      <div className={`relative ${isExpanded ? 'z-50' : ''}`} ref={containerRef}>
          {
              isExpanded && (
                  <div className="flex justify-center relative z-30" style={{ top: '-24px' }}>
                      <div style={{ left: `-96px`, width: '200px'}}
                           className="bg-white absolute p-2 rounded shadow shadow-2xl bottom-full min-w-full text-left">
                          <p className="text-gray-700 text-sm">
                              <strong>{getSupplierName(depot.supplier_code)} - {depot.code}</strong><br />
                              {depot.address}
                          </p>
                          {renderTriangle()}
                      </div>
                  </div>
              )
          }
          <CircleMapMarker
              onClick={handleClick}
              lat={depot.coordinates.y}
              lng={depot.coordinates.x}
              height={32}
              width={32}
              key={depot.id}
              className={`${isExpanded ? 'bg-blue-900' : (isInsideCircle ? 'bg-gray-500' : 'bg-blue')} z-20 cursor-pointer`}
          />
      </div>
    )
}

export default OutOfBoundDepotMarker;
